export const LOGO = "https://help.nflxext.com/helpcenter/OneTrust/oneTrust_production_2025-08-26/consent/87b6a5c0-0104-4e96-a291-092c11350111/0198e689-25fa-7d64-bb49-0f7e75f898d2/logos/dd6b162f-1a32-456a-9cfe-897231c7763c/4345ea78-053c-46d2-b11e-09adaef973dc/Netflix_Logo_PMS.png";
export const PROFILE_LOGO = "https://wallpapers.com/images/high/netflix-profile-pictures-1000-x-1000-qo9h82134t9nv0j0.webp";
export const API_OPTIONS = {
  method: 'GET',
  headers: {
    accept: 'application/json',
    Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI3ZjYxZjgxZDhkYzg1MjQwOTI0ZjAxMzYwMzAyMzg2YSIsIm5iZiI6MTc1OTc3MDQ3My42OTgsInN1YiI6IjY4ZTNmNzY5ZTE3MzZiOWU5ZDljYjAyYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.xGBCN6QgODNK5oGbUxPthC0Z7DYlYWQitju2Atmww1s'
  }
};
export const NOW_PLAYING_URL = 'https://api.themoviedb.org/3/movie/now_playing?page=1';
export const POPULAR_URL = 'https://api.themoviedb.org/3/movie/popular?language=en-US&page=1';
export const TOP_RATED_URL = 'https://api.themoviedb.org/3/movie/top_rated?language=en-US&page=1';
export const UPCOMING_URL = 'https://api.themoviedb.org/3/movie/upcoming?language=en-US&page=1';
export const DETAILS_URL = 'https://api.themoviedb.org/3/movie/';
export const IMAGE_CDN_URL = "https://image.tmdb.org/t/p/w500/"
export const BG_URL="https://assets.nflxext.com/ffe/siteui/vlv3/d482944d-eab4-4a64-89c9-a07a508a6e42/web/IN-en-20250929-TRIFECTA-perspective_4cf0c8a1-bd35-4d72-a49f-165021531dde_large.jpg"
export const SUPPORTED_LANGUAGES = [
  { identifier: "en", name: "English" },
  { identifier: "hindi", name: "Hindi" },
  { identifier: "spanish", name: "Spanish" },
]

export const GEMINI_API_KEY = process.env.REACT_APP_GEMINI_API_KEY;